// @ts-ignore
import decomp from 'poly-decomp';

// @ts-ignore
window.decomp = decomp;
